






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import { colors } from '../config';

More(Highcharts);

// Highcharts.addEvent = function (el: any, type: any, fn: any, options: any) {
//     if (options === void 0) { options = {}; }
//     /* eslint-enable valid-jsdoc */
//     var events, addEventListener = (el.addEventListener || Highcharts.addEventListenerPolyfill);
//     // If we're setting events directly on the constructor, use a separate
//     // collection, `protoEvents` to distinguish it from the item events in
//     // `hcEvents`.
//     if (typeof el === 'function' && el.prototype) {
//         events = el.prototype.protoEvents = el.prototype.protoEvents || {};
//     }
//     else {
//         events = el.hcEvents = el.hcEvents || {};
//     }
//     // Allow click events added to points, otherwise they will be prevented by
//     // the TouchPointer.pinch function after a pinch zoom operation (#7091).
//     if (Highcharts.Point &&
//         el instanceof Highcharts.Point &&
//         el.series &&
//         el.series.chart) {
//         el.series.chart.runTrackerClick = true;
//     }
//     // Handle DOM events
//     if (addEventListener) {
//         addEventListener.call(el, type, fn, {passive: true, capture: false});
//     }
//     if (!events[type]) {
//         events[type] = [];
//     }
//     var eventObject = {
//         fn: fn,
//         order: typeof options.order === 'number' ? options.order : Infinity
//     };
//     events[type].push(eventObject);
//     // Order the calls
//     events[type].sort(function (a: any, b: any) {
//         return a.order - b.order;
//     });
//     // Return a function that can be called to remove this event.
//     return function () {
//         Highcharts.removeEvent(el, type, fn);
//     };
// };

@Component({components: {Chart}})
export default class Compass extends Vue {
    @Prop() readonly rankings!: any;
    @Prop() readonly years!: number;
    @Prop() readonly showBransch!: boolean;
    @Prop({default: true}) readonly showLabels!: boolean;

    chartOptions: any = {
      chart: {
        polar: true,
        type: 'area',
        height: '65%',
        backgroundColor: 'transparent',
      },

      credits: {
        enabled: false,
      },

      title: null,

      pane: {
        size: '80%',
      },

      xAxis: {
        categories: ['<b>Avkastning</b>', 'Rörelsemarginal', 'Tillväxt', '<b>Framtids-</b><br/><b>utsikter</b>', 'Soliditet', 'Rörelsekapital i % av omsättning', '<b>Finansiell styrka</b>', 'Kassalikviditet', 'Räntetäckningsgrad', '<b>Kortsiktig beredskap</b>', 'Riskbuffert', 'Räntabilitet på eget kapital'],
        tickmarkPlacement: 'on',
        lineWidth: 0,
        plotLines: [
            {
                color: colors.DarkGrey,
                width: 1.5,
                zIndex: 1,
                value: 0,
            },
            {
                color: colors.DarkGrey,
                width: 1.5,
                zIndex: 1,
                value: 3,
            },
            {
                color: colors.DarkGrey,
                width: 1.5,
                zIndex: 1,
                value: 6,
            },
            {
                color: colors.DarkGrey,
                width: 1.5,
                zIndex: 1,
                value: 9,
            },
        ],
        labels: {
          enabled: true,
          style: {
            fontSize: '1rem',
          },
        },
      },

      yAxis: {
        gridLineInterpolation: 'polygon',
        gridLineDashStyle: 'longdash',
        lineWidth: 0,
        min: 0,
        max: 100,
        tickInterval: 10,
        labels: {
          enabled: false,
        },
      },

      tooltip: {
        shared: true,
        useHTML: true,
        headerFormat: '<table>',
        pointFormat: '<tr><td style="font-size: 1rem;">{series.name}</td><td style="text-align: right; font-size: 1.5rem; padding-left: 10px"><b>{point.y}</b></td></tr>',
        footerFormat: '</table>',
      },

      legend: {
        reversed: true,
        enabled: true,
        floating: true,
        borderWidth: 0,
        align: 'left',
        verticalAlign: 'top',
        x: 0,
        y: 0,
        layout: 'vertical',
        itemStyle: {
          font: '1rem Assistant, Verdana, sans-serif',
        },
      },

      plotOptions: {
        series: {
          fillOpacity: 0.5,
          marker: {
            radius: 0,
            states: {
              hover: {
                radius: 5,
              },
            },
            symbol: 'circle',
          },
          lineWidth: 1,
          pointPlacement: 'on',
        },
      },

      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },

      series: [],
    };

    @Watch('rankings', { immediate: true, deep: true })
    onRankingsChanged() {
      if (this.rankings === undefined) {
        return;
      }
      if (this.rankings.sheets === undefined) {
        return;
      }
      this.chartOptions.series = [];
      for (let i = 0; i < this.rankings.count; i++) {
        if (i === this.years) {
          break;
        }
        const sheet = this.rankings.sheets[i];
        this.chartOptions.series.unshift({
          name: `${sheet.DATE_TO.substring(0, 7)} (${sheet.MONTHS} mån)`,
          data: this.rankingValues(i),
          color: [colors.Primary, colors.Secondary, colors.Tertiary][i],
          lineColor: [colors.Primary, colors.Secondary, colors.Tertiary][i],
        });
      }
      const br = this.rankings.sheets[0].industryRanks;
      if (this.showBransch && br.score !== 0) {
        this.chartOptions.series.unshift({
          name: 'Branschmedian',
          data: [
              br.yield, br.operatingMargin, br.growth, br.longTerm,
              br.solidity, br.workingCapitalPct, br.financialStrength, br.quickRatio,
              br.interestCoverage, br.shortTerm, br.riskBuffer, br.returnOnCapital,
          ],
          color: colors.DarkGrey,
          lineColor: colors.DarkGrey,
          fillColor: 'rgba(0, 0, 0, 0.0)',
          lineWidth: 2,
          dashStyle: 'longDash',
          visible: true,
        });
      }
    }

    rankingValues(i: number) {
        if (!this.rankings.sheets) {
        return [];
        }
        const r = this.rankings.sheets[i].ranks;
        return [
            this.withLabel(r.yield),
            r.operatingMargin,
            r.growth,
            this.withLabel(r.longTerm),
            r.solidity,
            r.workingCapitalPct,
            this.withLabel(r.financialStrength),
            r.quickRatio,
            r.interestCoverage,
            this.withLabel(r.shortTerm),
            r.riskBuffer,
            r.returnOnCapital,
        ];
    }

    withLabel(v: any) {
      if (!this.showLabels) {
        return v;
      }
      return {
          dataLabels: {
              enabled: true,
              align: 'center',
              backgroundColor: colors.Primary,
              color: '#fff',
              allowOverlap: true,
              style: {
              textOutline: false,
              fontSize: '1rem',
              fontWeight: 'bold',
              },
              verticalAlign: 'middle',
          },
          y: v,
      };
    }
}


